import { render } from "./providerRegistration.vue?vue&type=template&id=33a4ca9d&scoped=true&ts=true"
import script from "./providerRegistration.vue?vue&type=script&lang=ts"
export * from "./providerRegistration.vue?vue&type=script&lang=ts"

import "./providerRegistration.vue?vue&type=style&index=0&id=33a4ca9d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a4ca9d"]])

export default __exports__